import * as ui from './shared/store/ui/ui.reducer';
import * as auth from './auth/store/reducers/auth.reducer';
import * as landing from './landing/store/reducers/landing.reducer';
import * as core from './core/store/reducers/core.reducer';
import {ActionReducerMap} from '@ngrx/store';
import * as theme from './theme/store/reducers/theme.reducer';

export interface AppState {
  ui: ui.State;
  auth: auth.State;
  landing: landing.State;
  core: core.State;
  theme: theme.State;
}
export const appReducers: ActionReducerMap<AppState> = {
  ui: ui.uiReducer,
  auth: auth.reducer,
  landing: landing.reducer,
  core: core.reducer,
  theme: theme.reducer
};
